import React from 'react'
import PropTypes from 'prop-types'

import './PageHeader.css'

export const PageHeader = ({ header }) => (
  <h2 styleName='header'>{header}</h2>
)

PageHeader.propTypes = {
  header: PropTypes.string.isRequired
}
